export interface FinanceSalesValues {
  loadedQuantities?: number;
  totalReturnedQuantities?: number;
  averagePrice?: number;
  averageTaxPrice?: number;
  taxPerUnit?: number;
  loadedAmount?: number;
  loadedTaxAmount?: number;
  loadedVAT?: number;
  returnedAmount?: number;
  returnedTaxAmount?: number;
  returnedVAT?: number;
}

export const FinanceNetAmount = (gross: number, returned: number): number =>
  Math.round((gross - returned) * 100) / 100;

export const FinanceSalesAmounts = (row: FinanceSalesValues) => {
  const loadedQty = row.loadedQuantities || 0;
  const returnedQty = row.totalReturnedQuantities || 0;
  const loadedIncl = row.loadedAmount ?? loadedQty * (row.averagePrice || 0);
  const loadedExcl = row.loadedTaxAmount ?? loadedQty * (row.averageTaxPrice || 0);
  const loadedVat = row.loadedVAT ?? loadedQty * (row.taxPerUnit || 0);
  const returnedIncl = row.returnedAmount ?? returnedQty * (row.averagePrice || 0);
  const returnedExcl = row.returnedTaxAmount ?? returnedQty * (row.averageTaxPrice || 0);
  const returnedVat = row.returnedVAT ?? returnedQty * (row.taxPerUnit || 0);
  return {
    loadedIncl, loadedExcl, loadedVat, returnedIncl, returnedExcl, returnedVat,
    netIncl: FinanceNetAmount(loadedIncl, returnedIncl),
    netExcl: FinanceNetAmount(loadedExcl, returnedExcl),
    netVat: FinanceNetAmount(loadedVat, returnedVat),
  };
};

export interface FinanceOrderValues {
  variant?: { _id?: string };
  quantityType?: number;
  totalQuantities?: number;
  totalAmount?: number;
  totalTaxAmount?: number;
  tax?: number;
  averagePrice?: number;
  averageTaxPrice?: number;
  taxPerUnit?: number;
}

export const ConsolidateFinanceOrders = <Record extends FinanceOrderValues>(rows: Record[]) => {
  const groups = new Map<string, Record & { orderCount: number }>();
  for (const row of rows) {
    const key = `${row.variant?._id || ''}-${row.quantityType}`;
    const previous = groups.get(key);
    if (!previous) groups.set(key, { ...row, orderCount: 1 });
    else {
      previous.totalQuantities = (previous.totalQuantities || 0) + (row.totalQuantities || 0);
      previous.totalAmount = (previous.totalAmount || 0) + (row.totalAmount || 0);
      previous.totalTaxAmount = (previous.totalTaxAmount || 0) + (row.totalTaxAmount || 0);
      previous.tax = (previous.tax || 0) + (row.tax || 0);
      previous.orderCount++;
    }
  }
  return Array.from(groups.values()).map((row) => {
    const quantity = row.totalQuantities || 0;
    const averagePrice = quantity > 0 ? Number(((row.totalAmount || 0) / quantity).toFixed(2)) : (row.averagePrice || 0);
    const averageTaxPrice = quantity > 0 ? Number(((row.totalTaxAmount || 0) / quantity).toFixed(2)) : (row.averageTaxPrice || 0);
    return { ...row, averagePrice, averageTaxPrice, taxPerUnit: FinanceNetAmount(averagePrice, averageTaxPrice) };
  });
};